import React from 'react';
import PropTypes from 'prop-types';
import { TableBody, TableRow } from '@mui/material';
import { sequence } from '@totalsoft/change-tracking-react';
import FinancialProductPropertiesTableRow from './FinancialProductPropertiesTableRow';
import { useTranslation } from 'react-i18next';
import { isValid } from '@totalsoft/pure-validations-react';
import { Typography } from '@totalsoft/rocket-ui';

const FinancialProductPropertiesTableBody = ({ canWrite, onCancelEdit, onDelete, onSave, properties, propertiesData, validation }) => {
  const [t] = useTranslation();

  return (
    <TableBody>
      {!isValid(validation) &&
        !sequence(properties)?.find((_, index) => {
          return !isValid(validation[index]);
        }) && (
          <TableRow>
            <Typography color='error'>{t('FinancialProduct.Details.Properties.ValidationList')}</Typography>
          </TableRow>
        )}
      {sequence(properties)?.map((data, index) => {
        return (
          <FinancialProductPropertiesTableRow
            canWrite={canWrite}
            key={index}
            dataLens={data}
            properties={propertiesData}
            index={index}
            onCancelEdit={onCancelEdit}
            onDelete={onDelete}
            onSave={onSave}
            validation={validation}
          />
        );
      })}
    </TableBody>
  );
};

FinancialProductPropertiesTableBody.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  onCancelEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  properties: PropTypes.array.isRequired,
  propertiesData: PropTypes.array.isRequired,
  validation: PropTypes.object.isRequired
};

export default FinancialProductPropertiesTableBody;
